import { ISelectItem } from "../../components/ui/select";
import fetcher from "../../lib/fetcher";
import useSWR from "swr";

export interface IFacilityTypeSchema {
  id: number;
  fullTitle: string;
  shortTitle: string;
  roomCount: number;
  isStudio: boolean;
}

interface IFacilityTypeResponse {
  data: IFacilityTypeSchema[];
}

const useFacilityType = <T extends boolean | undefined = undefined>(isFetch?: boolean, isTransform?: T) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    isFetch === undefined || isFetch === true ? `/facility/type` : null,
    (url) => fetcher.swr<IFacilityTypeResponse>(url),
    {}
  );

  const transformData = (
    dataRes: IFacilityTypeResponse | undefined | null
  ): ISelectItem[] => {
    if (dataRes) {
      return dataRes?.data?.map((item) => ({
        key: item.id,
        label: item.fullTitle,
      }));
    }
    return [];
  };

  type FacilityTypeListType = T extends true
  ? ISelectItem[]
  : IFacilityTypeSchema[];

  return {
    facilityTypeList: (isTransform ? transformData(data) : data?.data || []) as FacilityTypeListType,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useFacilityType;
